import Dashboard from './Dashboard';
import MapMapper from './MapMapper';

const map = {
  Dashboard,
  MapMapper,
};

export default map;
